export const SET_ATTRIBUTE_FIELD = 'SET_ATTRIBUTE_FIELD';

export function setAttributeField(key, value) {
    return { type: SET_ATTRIBUTE_FIELD, key, value };
}
